import * as Yup from "yup";

export interface Careplan {
  icdCodes: any;
  intervention: unknown;
  preventive_schedule: unknown;
  assignedBy?: string;
  startDate?: string;
  endDate?: string;
  title: string;
  // condition?: string;
  deception?: string;
  active?: boolean;
  goals?: string;
}

export const CAREPLAN_INITIAL_VALUE: Careplan = {
  icdCodes: undefined,
  assignedBy: undefined,
  startDate: new Date().toISOString(),
  endDate: undefined,
  title: "",
  // condition: undefined,
  deception: "",
  active: true,
  goals: undefined,
  preventive_schedule: undefined,
  intervention: undefined,
};

export const CAREPLAN_VALIDATION_SCHEMA = Yup.object().shape({
  title: Yup.string().trim().required().label("Title"),
  startDate: Yup.string().required().label("Start Date"),
});
